export default "__VITE_ASSET__Df$v$95C__"